import { DocumentListService } from '@services/document/document-list.service';
import { Injectable, inject } from '@angular/core';
import {
  BroadcastService,
  SearchService,
  ChangedDocumentService,
  CurrentDocumentService,
  DataService,
  DocumentService,
  DocumentSaveService,
  LocalStorageService,
  NotificationService,
  OfflineUtilService,
  UnsavedDocumentService,
  MandatoryFieldService,
  ModifiedFieldService,
  ClientRulesService,
  ValidationService,
  LoggedInUserService,
  WebSocketService,
  FileProviderService,
  ComponentService,
  FinaliseValueFieldService,
  OfflineStatusService,
  KeyValueStorageService,
  SearchQueriesService,
  SearchClientService,
  NavigationService,
  PendingOperationService,
  LazyScriptLoaderService
} from '@formbird/services';
import { AuditService } from '../audit/audit.service';
import { ModalService } from '../modal/modal.service';
import { RouterService } from '../../../app-routing/router.service';
import { ImageCompressionService } from '../image-compression.service';
import { ImageGalleryService } from '../image-gallery.service';
import { DocumentModalService } from '../modal/document-modal.service';

@Injectable({
  providedIn: 'root'
})
export class FormbirdInjectorService {
  private searchService = inject(SearchService);
  private changedDocumentService = inject(ChangedDocumentService);
  private broadcastService = inject(BroadcastService);
  private notificationService = inject(NotificationService);
  private dataService = inject(DataService);
  private localStorageService = inject(LocalStorageService);
  private mandatoryFieldService = inject(MandatoryFieldService);
  private modifiedFieldService = inject(ModifiedFieldService);
  private documentListService = inject(DocumentListService);
  private unsavedDocumentService = inject(UnsavedDocumentService);
  private currentDocumentService = inject(CurrentDocumentService);
  private offlineUtilService = inject(OfflineUtilService);
  private documentService = inject(DocumentService);
  private documentSaveService = inject(DocumentSaveService);
  private clientRulesService = inject(ClientRulesService);
  private modalService = inject(ModalService);
  private routerService = inject(RouterService);
  private validationService = inject(ValidationService);
  private loggedInUserService = inject(LoggedInUserService);
  private webSocketService = inject(WebSocketService);
  private fileProviderService = inject(FileProviderService);
  private imageCompressionService = inject(ImageCompressionService);
  private imageGalleryService = inject(ImageGalleryService);
  private documentModalService = inject(DocumentModalService);
  private componentService = inject(ComponentService);
  private auditService = inject(AuditService);
  private finaliseFieldValueService = inject(FinaliseValueFieldService);
  private offlineStatusService = inject(OfflineStatusService);
  private keyValueStorageService = inject(KeyValueStorageService);
  private searchQueriesService = inject(SearchQueriesService);
  private searchClientService = inject(SearchClientService);
  private navigationService = inject(NavigationService);
  private pendingOperationService = inject(PendingOperationService);
  private lazyScriptLoaderService = inject(LazyScriptLoaderService);


  /**
   * set up service to be called globally from components and other code external to the Angular app
   */
  setupServices() {
    (<any>window).FormbirdServiceInjector = {
      /**
       * return the service matching the name
       */
      get(serviceName: string) {
        if (serviceName) {
          return this[serviceName];
        }
      },

      SearchService: this.searchService,
      ChangedDocumentService: this.changedDocumentService,
      BroadcastService: this.broadcastService,
      NotificationService: this.notificationService,
      DataService: this.dataService,
      LocalStorageService: this.localStorageService,
      MandatoryFieldService: this.mandatoryFieldService,
      ModifiedFieldService: this.modifiedFieldService,
      DocumentListService: this.documentListService,
      UnsavedDocumentService: this.unsavedDocumentService,
      CurrentDocumentService: this.currentDocumentService,
      OfflineUtilService: this.offlineUtilService,
      OfflineStatusService: this.offlineStatusService,
      DocumentService: this.documentService,
      DocumentSaveService: this.documentSaveService,
      ClientRulesService: this.clientRulesService,
      ModalService: this.modalService,
      RouterService: this.routerService,
      ValidationService: this.validationService,
      LoggedInUserService: this.loggedInUserService,
      WebSocketService: this.webSocketService,
      FileProviderService: this.fileProviderService,
      ImageCompressionService: this.imageCompressionService,
      ImageGalleryService: this.imageGalleryService,
      DocumentModalService: this.documentModalService,
      ComponentService: this.componentService,
      AuditService: this.auditService,
      FinaliseValueFieldService: this.finaliseFieldValueService,
      KeyValueStorageService: this.keyValueStorageService,
      DatatablesQueriesService: this.searchQueriesService,
      SearchQueriesService: this.searchQueriesService,
      SearchClientService: this.searchClientService,
      NavigationService: this.navigationService,
      PendingOperationService: this.pendingOperationService,
      LazyScriptLoaderService: this.lazyScriptLoaderService
    };
  }
}
